export enum ReceiptOccurenceEnum {
  UNPERFORMED_OPERATION = 'unperformed_operation',
  PARTIAL_RETURN = 'partial_return',
  TOTAL_RETURN = 'total_return',
}

export const ReceiptOccurenceLabels: Record<ReceiptOccurenceEnum, string> = {
  [ReceiptOccurenceEnum.UNPERFORMED_OPERATION]: 'Recusa',
  [ReceiptOccurenceEnum.PARTIAL_RETURN]: 'Devolução parcial',
  [ReceiptOccurenceEnum.TOTAL_RETURN]: 'Devolução total',
};

export const ReceiptOccurenceArray = Object.entries(ReceiptOccurenceLabels).map(
  ([value, title]) => ({
    value: value as ReceiptOccurenceEnum,
    title,
  })
);
